__turbopack_context__.v({
  "course": "hSR4ta_course",
  "course-sequence": "hSR4ta_course-sequence",
  "course-sequence--scroll": "hSR4ta_course-sequence--scroll",
  "fine-print": "hSR4ta_fine-print",
  "list": "hSR4ta_list",
  "logos": "hSR4ta_logos",
  "section": "hSR4ta_section",
  "section--last": "hSR4ta_section--last",
  "subtitle": "hSR4ta_subtitle",
  "video": "hSR4ta_video",
});
